export const GET_TWILIO_ACCESS_TOKEN = gql`
  query GetTwilioAccessToken {
    getTwilioAccessToken {
      accessToken
    }
  }
`
